import { useCallback, useState } from 'react'

export interface ConfirmCreate {
  /** The headings of the PMs about to be created, while the prompt is open. */
  pending: string[] | undefined
  /** Open the prompt, resolving to the editor's answer once they give one. */
  ask: (headings: string[]) => Promise<boolean>
  answer: (confirmed: boolean) => void
}

/**
 * Asks before one click creates several PMs. The create awaits `ask`, so the
 * submit button stays disabled while the prompt is open.
 */
export const useConfirmCreate = (): ConfirmCreate => {
  const [request, setRequest] = useState<{
    headings: string[]
    resolve: (confirmed: boolean) => void
  }>()

  const ask = useCallback((headings: string[]) => new Promise<boolean>((resolve) => {
    setRequest({ headings, resolve })
  }), [])

  const answer = useCallback((confirmed: boolean) => {
    request?.resolve(confirmed)
    setRequest(undefined)
  }, [request])

  return { pending: request?.headings, ask, answer }
}
